import React, { useState, useRef, useEffect } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import ListingComponent from '../../components/ListingComponent';
import { useParams } from  'react-router-dom'
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Multiselect from 'multiselect-react-dropdown';

const Listing = (props) => {
  const defaultHeaderConfig = { disableSort: true };
  const navigate = useNavigate();
  const params = useParams();
  const circleRef = useRef();
  const [updateApi] = getApi('updateUser');
  const [fetchBranchApi] = getApi('branches');
  const [branch, setBranch] = useState(null);
  const [branches, setBranches] = useState([]);

  useEffect(()=>{
    fetchBranches();
  }, [])

  const fetchBranches = async () => {
    try {
      let response = await fetchBranchApi(params).unwrap();
      setBranches(response.data.branches)
    } catch {
      toast.error("Branches not found")
    }
  }

    const handleBranchMap = async () => {
    if(branch == null) {
      toast.error("Please select branch.")
      return
    }
    try {
      let parameter = {
        id: params.id,
        user: {
          circle_user_mappings_attributes: [{branch_id: branch, user_id: params.id, company_id: 2, is_valid: true}]
        }
      }
      await updateApi(parameter).unwrap();
      window.location.reload();
      // dispatch(resetQueryParams())
    } catch {
      toast.error("Something went wrong.")
    }
  }

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'circle',
      value: (row) => row.branch.name,
    },
    {
      ...defaultHeaderConfig,
      label: 'Valid',
      value: (row) => row.is_valid ? "True" : "False",
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at'
    },
  ]
  const onBranchSelect = (_, selectedItem) => {
    setBranch(selectedItem.id)
  }

  return <>
  <div className="row">
    <div className="col-md-2 mx-2">
      <label htmlFor="zones" className='form-label'>Select Branches</label>
      <Multiselect
       id="zones"
       options={branches}
       selectedValues={props.branches}
       onSelect={onBranchSelect}
       placeholder='Select from options'
       displayValue={'name'}
       showArrow={true}
       customArrow={true}
       singleSelect={true}
       avoidHighlightFirstOption={true}
       disablePreSelectedValues={true}
       ref={circleRef}
     />
   </div>
    <div className="col-md-2 my-3">
      <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleBranchMap}> Map Branch </button>
    </div>
 </div>
  <ListingComponent
    key={"PAGES.WorkOrdersListingPage.name"}
    listingMutation={getApi('circleUserMappings')}
    contentHeading="Circle-User Mappings"
    headers={headers}
    params={{id: params.id}}
    recordsKey="circle_user_mappings"
    hideSearch={true}
  /></>
};

export default Listing;
